var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_314_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.57511 0.236373C4.90205 -0.0794053 5.43151 -0.077843 5.75683 0.239302C6.08236 0.556642 6.08075 1.07005 5.75381 1.38583L2.01881 4.9998L5.75381 8.61376C6.08075 8.92954 6.08236 9.44295 5.75683 9.76029C5.43151 10.0774 4.90205 10.079 4.57511 9.76322L0.243212 5.5714C-0.0823147 5.25425 -0.0807044 4.74065 0.246231 4.42507L4.57511 0.236373Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_314_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 6,
    fill: "white",
    transform: "translate(6) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrv);
export default __webpack_public_path__ + "static/media/prv.855690ff7095531a8930f88a546baf7a.svg";
export { ForwardRef as ReactComponent };